(() => {
  const canvas = document.getElementById("shader-canvas");
  if (!canvas) return;

  const gl =
    canvas.getContext("webgl2") ||
    canvas.getContext("webgl");

  if (!gl) return;

  const dpr = Math.max(1, 0.5 * window.devicePixelRatio);

  function resize() {
    canvas.width = innerWidth * dpr;
    canvas.height = innerHeight * dpr;
    gl.viewport(0, 0, canvas.width, canvas.height);
  }

  window.addEventListener("resize", resize);
  resize();

  const vertexSrc = `#version 300 es
  in vec2 position;
  void main(){gl_Position=vec4(position,0.,1.);}
  `;

  const fragmentSrc = `#version 300 es
  precision highp float;
  out vec4 O;
  uniform vec2 resolution;
  uniform float time;
  #define FC gl_FragCoord.xy
  #define T time
  #define R resolution
  #define MN min(R.x,R.y)

  float rnd(vec2 p){
    p=fract(p*vec2(12.9898,78.233));
    p+=dot(p,p+34.56);
    return fract(p.x*p.y);
  }

  float noise(vec2 p){
    vec2 i=floor(p),f=fract(p),u=f*f*(3.-2.*f);
    float a=rnd(i),b=rnd(i+vec2(1,0)),
    c=rnd(i+vec2(0,1)),d=rnd(i+1.);
    return mix(mix(a,b,u.x),mix(c,d,u.x),u.y);
  }

  float fbm(vec2 p){
    float t=0.,a=1.;
    mat2 m=mat2(1.,-.5,.2,1.2);
    for(int i=0;i<5;i++){
      t+=a*noise(p);
      p*=2.*m;
      a*=.5;
    }
    return t;
  }

  float clouds(vec2 p){
    float d=1.,t=0.;
    for(float i=0.;i<3.;i++){
      float a=d*fbm(i*10.+p.x*.2+.2*(1.+i)*p.y+d+i*i+p);
      t=mix(t,d,a);
      d=a;
      p*=2./(i+1.);
    }
    return t;
  }

  void main(){
    vec2 uv=(FC-.5*R)/MN;
    vec3 col=vec3(0);
    float bg=clouds(vec2(uv.x+T*.5,-uv.y));
    uv*=1.-.3*(sin(T*.2)*.5+.5);
    for(float i=1.;i<12.;i++){
      uv+=.1*cos(i*vec2(.1+.01*i,.8)+i*i+T*.5+.1*uv.x);
      float d=length(uv);
      vec3 glow = vec3(1.0, 0.85, 0.6);
col += .0009 / d * glow;

      float b=noise(i+uv+bg*1.731);
      vec3 wine = vec3(
  bg * 0.35,
  bg * 0.08,
  bg * 0.15
);

col = mix(col, wine, d);

    }
    O=vec4(col,1);
  }`;

  function compile(type, src) {
    const s = gl.createShader(type);
    gl.shaderSource(s, src);
    gl.compileShader(s);
    return s;
  }

  const program = gl.createProgram();
  gl.attachShader(program, compile(gl.VERTEX_SHADER, vertexSrc));
  gl.attachShader(program, compile(gl.FRAGMENT_SHADER, fragmentSrc));
  gl.linkProgram(program);
  gl.useProgram(program);

  const buffer = gl.createBuffer();
  gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
  gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([
    -1, 1, -1, -1, 1, 1, 1, -1
  ]), gl.STATIC_DRAW);

  const pos = gl.getAttribLocation(program, "position");
  gl.enableVertexAttribArray(pos);
  gl.vertexAttribPointer(pos, 2, gl.FLOAT, false, 0, 0);

  const uRes = gl.getUniformLocation(program, "resolution");
  const uTime = gl.getUniformLocation(program, "time");

  function loop(t) {
    gl.uniform2f(uRes, canvas.width, canvas.height);
    gl.uniform1f(uTime, t * 0.001);
    gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
    requestAnimationFrame(loop);
  }

  loop(0);
})();
